// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as SuspensionInfoEntityMapper from "../entity-mapper/SuspensionInfoEntityMapper.bs.js";
import * as SuspensionReasonEntityMapper from "../entity-mapper/SuspensionReasonEntityMapper.bs.js";

var execute = SuspensionInfoEntityMapper.execute;

var SuspensionInfoResponseConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var SuspensionInfoResponseConverter = partial_arg(SuspensionInfoResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = SuspensionReasonEntityMapper.execute;

var SuspensionReasonsResponseConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var SuspensionReasonsResponseConverter = partial_arg$1(SuspensionReasonsResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  SuspensionInfoResponseConfig ,
  SuspensionInfoResponseConverter ,
  SuspensionReasonsResponseConfig ,
  SuspensionReasonsResponseConverter ,
  
}
/* SuspensionInfoResponseConverter Not a pure module */
